"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _isNil2 = _interopRequireDefault(require("lodash/isNil"));

var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var IconStar = function IconStar(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    className: "star_svg__path1",
    d: "M12.633 19.484l-7.388 3.884 1.411-8.226L.679 9.316l8.26-1.2L12.633.631l3.694 7.485 8.26 1.2-5.977 5.826 1.411 8.226z"
  }));
};

IconStar.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 25 24"
};
var starsMetaProps = {
  itemProp: 'starRating',
  itemScope: true,
  itemType: 'https://schema.org/Rating'
};

var HotelStars = function HotelStars(_ref) {
  var className = _ref.className,
      _ref$gap = _ref.gap,
      gap = _ref$gap === void 0 ? 2 : _ref$gap,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 15 : _ref$size,
      value = _ref.value,
      showMeta = _ref.showMeta;
  var startArr = !(0, _isNil2["default"])(value) ? Array.from(Array(value).keys()) : [];
  var metaProps = showMeta ? starsMetaProps : {};
  return !(0, _isEmpty2["default"])(startArr) ? /*#__PURE__*/_react["default"].createElement(StyledHotelStars, (0, _extends2["default"])({
    className: className,
    gap: gap
  }, metaProps), showMeta ? /*#__PURE__*/_react["default"].createElement("meta", {
    itemProp: "ratingValue",
    content: String(value)
  }) : null, startArr.map(function (item) {
    return /*#__PURE__*/_react["default"].createElement(StyledIconStar, {
      key: item,
      height: size
    });
  })) : null;
};

var StyledIconStar = (0, _styledComponents["default"])(IconStar).withConfig({
  displayName: "HotelStars__StyledIconStar",
  componentId: "sc-1tt0th8-0"
})(["", ""], function (_ref2) {
  var theme = _ref2.theme;
  return "\n    path {\n      fill: ".concat(theme.colors.gold, ";\n      stroke: ").concat(theme.colors.gold, ";\n      stroke-width: 1px;\n    }\n  ");
});

var StyledHotelStars = _styledComponents["default"].div.withConfig({
  displayName: "HotelStars__StyledHotelStars",
  componentId: "sc-1tt0th8-1"
})(["display:flex;flex-direction:row;margin-right:6px;", " + ", "{margin-left:", "px;}"], StyledIconStar, StyledIconStar, function (props) {
  return props.gap;
});

var _default = HotelStars;
exports["default"] = _default;